import { useState } from 'react';
import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";

import EditArtworkIcon from '@/assets/all-icons/edit-artwork-icon';
import useStateHandler from '@/hooks/useStateHandler';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import UpdateShippingItem from './UpdateShippingItem';

import './styles/ShippingItem.css';

export default function ShippingItem({ data, onSelectShippingData, onUpdateShippingData, onRemoveShippingData }) {
  const [openRemoveConfirmation, setOpenRemoveConfirmation] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  
  // Import stateHandler for triggering the global temporal popup.
  const { stateHandler } = useStateHandler();

  // Separate function to handle the removal of shipping information.
  // This function triggers the removal callback, fires the temporal popup,
  // and then closes the confirmation popup.
  function handleRemoveShipping() {
    onRemoveShippingData(data);
    stateHandler.set("temporalPopup", { 
      text: "Shipping information deleted successfully", 
      theme: true 
    });
    setOpenRemoveConfirmation(false);
  }

  return (
    <>
      {/* Clicking the container now updates the shipping option immediately */}
      <div className="shipping-item__container" onClick={() => onSelectShippingData(data)}>
        <DeleteIcon 
          className="shipping-item__remove" 
          onClick={e => {
            e.stopPropagation();
            setOpenRemoveConfirmation(true);
          }} 
        />
        <Text className="shipping-item__name dots-on-overflow" medium>
          {data.saved_shipping_name}
        </Text>
        <EditArtworkIcon 
          className="shipping-item__edit" 
          onClick={e => {
            e.stopPropagation();
            setOpenUpdateModal(true);
          }} 
        />
      </div>

      {/* Delete Confirmation Popup */}
      <GenericPopup className="shipping-item-container-remove-popup remove-scrollbar" open={openRemoveConfirmation} opacity>
        <div className="shipping-item-remove-popup__container">
          {/* Popup Title */}
          <div className="shipping-item-remove-popup__header">
            <Text className="shipping-item-remove-popup__text" medium>
              Do you want to <span>delete</span> this shipping information?
            </Text>
            <XIcon 
              className="shipping-item-remove-popup__close" 
              onClick={() => setOpenRemoveConfirmation(false)} 
            />
          </div>

          {/* "Yes, remove" button using ContinueButton */}
          <ContinueButton onClick={handleRemoveShipping}>
            Yes, remove
          </ContinueButton>
        </div>
      </GenericPopup>

      {/* Edit Shipping Option Popup */}
      <GenericPopup className="shipping-item-update-popup remove-scrollbar" open={openUpdateModal} opacity>
        <UpdateShippingItem 
          data={data} 
          onUpdateShippingData={onUpdateShippingData} 
          close={() => setOpenUpdateModal(false)} 
        />
      </GenericPopup>
    </>
  );
}
